import React from 'react';
import { NavLink, Outlet, useLocation } from 'react-router-dom';
import { Grid, Menu, Segment } from 'semantic-ui-react';
import RestrictedView from 'shared/RestrictedView';
import { USER_PERMISSIONS } from 'dyl-components';


const DYLAdmin = () => {
    const location = useLocation();

    return (
        <Grid>
            <Grid.Row style={{ paddingTop: 0, paddingBottom: 0 }}>
                <Grid.Column style={{ paddingTop: '1em', paddingRight: 0, paddingLeft: '0.5em' }}>
                    <Menu borderless pointing secondary color='primary' stackable size='huge'>
                        <RestrictedView type="disabled" userPermission={USER_PERMISSIONS.PHONE_MANAGEMENT_VIEW}>
                            <Menu.Item name='Banner Display' as={NavLink} to={"/settings/broadcast-message/banner-display"} active={location?.pathname?.includes("/banner-display")} />
                        </RestrictedView>
                        <RestrictedView type="disabled" userPermission={USER_PERMISSIONS.PHONE_MANAGEMENT_VIEW}>
                            <Menu.Item name='Message History' as={NavLink} to={"/settings/broadcast-message/message-history"} active={location?.pathname?.includes("/message-history")} />
                        </RestrictedView>
                    </Menu>
                    <Segment basic>
                        <Outlet />
                    </Segment>
                </Grid.Column>
            </Grid.Row>
        </Grid>
    );
}

export default DYLAdmin;
